import { Component, OnInit, Input, } from '@angular/core';
import { LayoutService } from '../../services/layout.service';
import { MsAdalAngular6Service } from 'microsoft-adal-angular6';
import { HelperService } from 'app/shared/services/helper/helper.service';

@Component({
  selector: 'app-header-side',
  templateUrl: './header-side.template.html',
  styleUrls: ['./header-side.template.scss']
})
export class HeaderSideComponent implements OnInit {

  @Input() notificPanel;
  layoutConf: any;

  nombreUsuario: string = "";

  constructor(private _layoutService: LayoutService,
              private _adalSvc: MsAdalAngular6Service,
              public _helperService: HelperService) {
    this.nombreUsuario = this._adalSvc.userInfo.profile.given_name;
  }

  ngOnInit() {
    this.layoutConf = this._layoutService.layoutConf;
  }

  toggleSidenav() {
    if (this.layoutConf.sidebarStyle === 'closed') {
      return this._layoutService.publishLayoutChange({
        sidebarStyle: 'full'
      })
    }
    this._layoutService.publishLayoutChange({
      sidebarStyle: 'closed'
    })
  }

  toggleCollapse() {
    // compact --> full
    if (this.layoutConf.sidebarStyle === 'compact') {
      return this._layoutService.publishLayoutChange({
        sidebarStyle: 'full'
      }, { transitionClass: true })
    }

    // * --> compact
    this._layoutService.publishLayoutChange({
      sidebarStyle: 'compact'
    }, { transitionClass: true })
  }
}
